import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  fontWeight: 'bold',
  textTransform: 'uppercase',
}));
